import { useState } from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Button from '@components/Button';
import { useTranslation } from '@hooks';
import { handleApiError } from '@helpers/api';

const ExportCSV = ({ callback, type }) => {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onExport = async () => {
        setIsSubmitting(true);
        try {
            const file = await callback();
            const anchor = document.createElement('a');
            anchor.style.display = 'none';
            anchor.href = file;
            anchor.download = `${type}.csv`;
            document.body.appendChild(anchor);
            anchor.click();
            window.URL.revokeObjectURL(file);
            anchor.remove();
        } catch (error) {
            handleApiError(error, 'common.exportError');
        }
        setIsSubmitting(false);
    };

    return (
        <Button
            variant="outlined"
            style={{ flexShrink: 0 }}
            startIcon={<FileDownloadIcon />}
            onClick={onExport}
            disabled={isSubmitting}
        >
            {t('buttons.exportAsCSV')}
        </Button>
    );
};

export default ExportCSV;
